/********************************************
* Form large
********************************************/
function fnFormLarge( i, oSection ) {

	var oSection			= $( oSection ),
		oInput				= $( 'input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=image]):not([type=file]), textarea', oSection );

	// On focus
	oInput.focus( function() {
		oThisInput 			= $( this );
		$( "label[for='" + oThisInput.attr( 'id' ) + "']" ).addClass( 'animate-label' );
	} );

	// No value
	oInput.blur( function() {
		oThisInput 			= $( this );

		if ( oThisInput.val() == '' ) {
			$( "label[for='" + oThisInput.attr( 'id' ) + "']" ).removeClass( 'animate-label' );
		}

	} );

	// Inputs with exiting value
	oInput.each( function() {
		oThisInput 			= $( this );
		if ( oThisInput.val().length > 0 ) {
			$( "label[for='" + oThisInput.attr( 'id' ) + "']" ).addClass( 'animate-label' );
		}
	} );

}


// END OF DOCUMENT
